import React from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import StudentSidebar from '../common/studentSidebar'
import { getUserProfile } from '../../../api/user'

const mockProfile = {
  fullname: 'Ronald Richard',
  nik: '1234567890123456',
  email: 'studentdemo@example.com',
  phone_number: '90154-91036',
  gender: 'Male',
  dob: '16 Jan 2000',
  profession: 'Software Developer',
  agency: 'PT. Teknologi Inovatif',
  bio: `Hello! I'm Ronald Richard. I'm passionate about developing innovative software solutions, analyzing classic literature. I aspire to become a software developer, work as an editor. In my free time, I enjoy coding, reading, hiking etc.`,
}

const StudentProfile = () => {
  const route = all_routes
  const [profile, setProfile] = React.useState<any>(mockProfile)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    getUserProfile()
      .then((data) => {
        setProfile({
          fullname: data.user.fullname,
          nik: data.user.nik,
          email: data.user.email,
          phone_number: data.user.phone_number,
          gender: data.user.gender,
          dob: data.user.dob,
          profession: data.user.profession,
          agency: data.user.agency,
          bio: data.user.bio,
        })
        setLoading(false)
      })
      .catch((err) => {
        setError('Gagal memuat data profil')
        setLoading(false)
        // fallback ke mockProfile
      })
  }, [])

  return (
    <>
      <Breadcrumb title="My Profile" />
      <div className="content">
        <div className="container">
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <div className="page-title d-flex align-items-center justify-content-between mb-4">
                <h5 className="fw-bold">My Profile</h5>
              </div>
              <div className="card mb-0">
                <div className="card-body">
                  <h6 className="fs-18 page-title fw-bold mb-4">
                    Basic Information
                  </h6>
                  {loading ? (
                    <div className="text-center my-5">Loading...</div>
                  ) : error ? (
                    <div className="alert alert-danger my-5">{error}</div>
                  ) : (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <h6>Nama Lengkap</h6>
                        <span>{profile.fullname || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>NIK</h6>
                        <span>{profile.nik || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>Email</h6>
                        <span>{profile.email || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>Nomor HP</h6>
                        <span>{profile.phone_number || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>Gender</h6>
                        <span>{profile.gender || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>DOB</h6>
                        <span>{profile.dob || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>Profesi</h6>
                        <span>{profile.profession || '-'}</span>
                      </div>
                      <div className="col-md-6 mb-3">
                        <h6>Instansi</h6>
                        <span>{profile.agency || '-'}</span>
                      </div>
                      <div className="col-md-12 mb-3">
                        <h6>Bio</h6>
                        <span>{profile.bio || '-'}</span>
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-content-end mt-4">
                    <Link
                      to={route.studentSettings}
                      className="btn btn-primary"
                    >
                      Ubah Profil
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StudentProfile
